import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Overview from 'components/Overview/Overview';
import {
  ActivitiesContextProvider,
  useActivitiesContext,
} from 'pages/Activities/activities.context';
import { UsersContextProvider } from 'context/users.context';
import { StoresContextProvider, useStoresContext } from 'pages/Stores/stores.context';
import { CampaignsContextProvider } from 'pages/Campaigns/campaigns.context';
import UpdateActivity from 'pages/Activities/UpdateActivity';
import CancelActivity from 'pages/Activities/CancelActivity';
import Loading from 'components/Messages/Loading/Loading';
import { Store } from '@restore/services-lib';
import { Div } from 'components/Elements/Div/Div';

const ActivityComponent = () => {
  const { activityId } = useParams();
  const { getActivityById, loading } = useActivitiesContext();
  const { getStoreById } = useStoresContext();
  const activity = getActivityById(Number(activityId));
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !activity) {
      navigate('/activities');
    }
  }, [activity, loading, navigate]);

  if (!activity) {
    return null;
  }

  if (loading) {
    return <Loading />;
  }

  const actions = (
    <Div display='flex' width='100%' justifyContent='center' gap='0.75rem'>
      <UpdateActivity activity={activity} />
      &nbsp;
      <CancelActivity activity={activity} />
    </Div>
  );

  return (
    <Overview
      title={activity.subject || '(no subject)'}
      entityType='Activity'
      description={activity.description}
      startDate={activity.startDate as Date}
      estTimeComp={activity.estimatedTimeToComplete}
      actTimeComp={activity.actualTimeToComplete || 0}
      dueDate={activity.dueDate}
      assignedTo={activity.assignedUsers.map((user) => `${user.firstName} ${user.lastName}`)}
      ccRecipients={activity.ccRecipients.map((user) => `${user.firstName} ${user.lastName}`)}
      tags={activity.tags}
      actions={actions}
      steps={activity.steps}
      campaign={activity.campaign?.name}
      stores={activity.assignedStores.map((store: Store) => store.name || 'N/A')}
      activity={activity}
    />
  );
};

const Activity = () => (
  <UsersContextProvider>
    <StoresContextProvider>
      <CampaignsContextProvider>
        <ActivitiesContextProvider>
          <ActivityComponent />
        </ActivitiesContextProvider>
      </CampaignsContextProvider>
    </StoresContextProvider>
  </UsersContextProvider>
);

export default Activity;
